// AUTO-GENERATED by scripts/gen-tw-scales.mjs from @kungal/ui-tokens — do not edit.
//
// The Tailwind scale names KunUI mints itself. `cn()` feeds them to
// tailwind-merge, which otherwise cannot parse them and silently keeps two
// conflicting classes.
export const KUN_TW_SCALES = {
  radius: ['kun-full', 'kun-lg', 'kun-md', 'kun-none', 'kun-sm'],
  shadow: ['kun-lg', 'kun-md', 'kun-sm'],
  ease: ['kun-emphasized', 'kun-in', 'kun-out', 'kun-standard'],
  animate: ['bounce', 'bounceInDown', 'bounceInRight', 'fadeInUp', 'fadeOutDown', 'shake', 'swing', 'tada'],
  z: ['kun-alert', 'kun-message', 'kun-modal', 'kun-popover', 'kun-sticky'],
  duration: ['kun-base', 'kun-exit', 'kun-fast', 'kun-slow'],
} as const
